module.exports = __webpack_public_path__ + "img/banner6.fb628abc.png";